export const INITIAL_HEIGHT_PERCENTAGE = 20;
export const FULL_HEIGHT_PERCENTAGE = 0;
export const TAP_THRESHOLD = 5;

export const SPRING_CONFIG = {
  tension: 200,
  friction: 30,
  clamp: true,
} as const;

export const DRAG_CONFIG = {
  yNormalisation: 0.2,
  velocityThreshold: 0.2,
  distanceThreshold: 5,
} as const;
